<template>
  <l-cache ref="cache" :get-data="getItem" :id="$route.query.id">
    <ReviewDetailsWx slot-scope="{data}" :form-data="data"></ReviewDetailsWx>
  </l-cache>
</template>
<script>
  import ReviewDetailsWx from './reviewDetails_wx'
  export default {
    name: 'reviewDetailBox',
    components: {ReviewDetailsWx},
    methods: {
      async getItem (key) {
        let {items} = await this.$store.dispatch('school/getApplyList', {pagination: {page: 1, rowsPerPage: 10}, search: {key: 'id', value: this.$route.query.id}})
        return items[0]
      }
    }
  }
</script>
